import getLocalIp from './ip';
import moment     from 'moment'
import axios      from 'axios';

module.exports = async (type, params) => {
  let json = [];
  let rights = localStorage.rights;
  if (typeof rights !== 'undefined') {
    json = JSON.parse(rights);
    var currentMount = window.location.pathname,
        app = 'RWM CMS',
        index,
        index2,
        finalParams = '';

    for (var i in params) {
      finalParams += '' + i + ': ' + params[i] + ' | ';
    }

    index = json.map((e) => {
      var route = '';
      if (app.toUpperCase() === e.app.toUpperCase()) {
        route = e.route.toUpperCase()
      }
      return route;
    }).indexOf(currentMount.toUpperCase());

    index2 = json[index].actions.map((e) => e.name.toUpperCase()).indexOf(type.toUpperCase());

    var moduleId = json[index].moduleId;
    var actionId = json[index].actions[index2].actionId;

    if (moduleId !== '' && actionId !== '') {
      var Module = Parse.Object.extend('ModulesWeb');
      var _module = new Module();
      _module.id = moduleId;

      var Action = Parse.Object.extend('Actions');
      var _action = new Action();
      _action.id = actionId;

      var queryApp = new Parse.Query('ModulesWeb');
      queryApp.include(['Apps'])
      queryApp.equalTo('objectId', moduleId);

      var query = new Parse.Query('AccessListWeb');
      query.equalTo('ModulesWeb', _module);
      query.equalTo('Actions', _action);
      query.matchesKeyInQuery('Apps', 'Apps', queryApp)

      let ipAddress,
          ipAddressLAN;

      try {
        ipAddressLAN = await getLocalIp();
      } catch (e) {
        // unable to get LAN IP Address
      }

      try {
        ipAddress = await axios.get('https://api.ipify.org?format=json');
      } catch (e) {
        // unable to get IP Address
      }

      query.first()
      .then((accessListWeb) => {
        let data = {
          AccessListWeb: accessListWeb,
          User: Parse.User.current(),
          params: finalParams
        };

        if (ipAddressLAN) {
          data.localIp = ipAddressLAN;
        }

        if (ipAddress && ipAddress.data) {
          data.clientIp = ipAddress.data.ip
        }

        if (navigator && navigator.userAgent) {
          data.userAgent = navigator.userAgent;
        }

        var AuditTrailsWeb = Parse.Object.extend('AuditTrailsWeb');
        var audit = new AuditTrailsWeb();

        audit.set(data);

        return audit.save();
      }).then((data) => {
        console.log("Audit Trail saved.");
      }).catch((err) => {
        console.log("saveTrail error: ", err);
      });
    } else {
      console.log("moduleId or actionId is undefined");
    }
  } else {
    console.log("rights is undefined");
  }
}



// WEBPACK FOOTER //
// ./utils/saveTrail.js